import { Button, InputField } from "@appretio/ui-kit";
import { useState } from "react";
import z from "zod";
import {
  form,
  userNamePasswordContainer as credentialsContainer
} from "./LoginPage.css";

export function CredentialsForm() {
  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });

  const [errors, setErrors] = useState<{
    username?: string;
    password?: string;
  }>({});

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    // Clear previous errors
    setErrors({});

    const schema = z.object({
      username: z
        .string()
        .min(1, "Username is required")
        .email("Invalid email format"),
      password: z.string().min(1, "Password is required")
    });

    const result = schema.safeParse({ ...credentials });

    if (!result.success) {
      // Extract and set field-specific errors
      const fieldErrors: { username?: string; password?: string } = {};

      result.error.errors.forEach((error) => {
        const field = error.path[0] as keyof typeof fieldErrors;
        if (field && !fieldErrors[field]) {
          fieldErrors[field] = error.message;
        }
      });

      setErrors(fieldErrors);
      return;
    }

    // Form is valid, proceed with login
  }

  return (
    <form className={form} onSubmit={handleSubmit}>
      <div className={credentialsContainer}>
        <InputField
          placeholder="Username"
          value={credentials.username}
          onChange={(event) =>
            setCredentials({ ...credentials, username: event.target.value })
          }
          name="username"
          autoComplete="username"
          error={errors.username}
        />

        <InputField
          placeholder="Password"
          value={credentials.password}
          onChange={(event) =>
            setCredentials({ ...credentials, password: event.target.value })
          }
          type="password"
          name="password"
          autoComplete="current-password"
          error={errors.password}
        />
      </div>

      <Button type="submit">Log in</Button>
    </form>
  );
}
